/**
 * @module Component
 */

/**
 * Базовый компонент.
 *
 * От него наследуются все остальные компоненты.
 */
export default class Component {
    /**
     * @param {jQuery} $block Соответствующий объекту блок страницы.
     */
    constructor($block) {
        /**
         * Соответствующий объекту блок страницы.
         * @type {jQuery}
         */
        this.$block = $block;

        if (!Component.getInstance($block)) {
            Component.instances.push(this);
        }
    }

    /**
     * Массив созданных объектов.
     */
    static instances = [];

    /**
     * Находит объект класса по шаблону.
     *
     * @param {jQuery} $block Шаблон.
     * @return {Component} Объект.
     */
    static getInstance($block) {
        return this.instances.find(instance => instance.$block.is($block));
    }

    /**
     * Создаёт компоненты для всех вхождений со значениями по умолчанию.
     */
    static create() {
        $(`.${this.className}`).each((index, block) => {
            const $block = $(block);

            /* Если данный экземпляр уже в коллекции, то пропускаем. */
            if (this.getInstance($block)) return;

            const obj = new this($block);
            obj.init();
        });
    }

    /**
     * Инициализирует компонент.
     *
     * @param {Object} [options = {}] Параметры компонента.
     * @param {Object} [pluginOptions = {}] Настройки плагина.
     */
    init(options = {}, pluginOptions = {}) {
        this.initElements();
        this.setTemplateProperties();
        this.setProperties(options);
        this.initPlugin(pluginOptions);
    }

    /**
     * Заполняет объект элементов DOM.
     */
    initElements() {
        /**
         * Элементы блока.
         */
        this.elements = {};
    }

    /**
     * Прописывает поля класса из шаблона.
     */
    setTemplateProperties() {}

    /**
     * Прописывает поля класса.
     */
    setProperties() {}

    /**
     * Прописывает настройки плагина и инициализирует новый блок.
     */
    initPlugin() {}
}
